export const rewardfulScript = () => {
  return <script async src="https://r.wdfl.co/rw.js" data-rewardful="4e050b" />;
};
export const rewardfulBlobScript = () => {
  return (
    <script>{`(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`}</script>
  );
};
